import {JurisdictionsData} from './types'

export const jurisdictionsData: () => JurisdictionsData = () =>
  require('../../public/jurisdictions/data.json')
